import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import styles from './PriceTable.module.css'


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 224 }}
    >
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab label="design package" {...a11yProps(0)} />
        <Tab label="cording package" {...a11yProps(1)} />
        <Tab label="full package" {...a11yProps(2)} />
        <Tab label="option" {...a11yProps(3)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <div className={styles.price_wrapper}>
            <div className={styles.row}>
                <div>ランディングページ デザイン制作</div>
                <div>￥200,000</div>
            </div>
        </div>
        <div className={styles.total_price}>total：￥200,000</div>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <div className={styles.price_wrapper}>
            <div className={styles.row}>
                <div>ランディングページ デザイン制作</div>
                <div>￥200,000</div>
            </div>
            <div className={styles.row}>
                <div>ランディングページ コーディング実装</div>
                <div>￥100,000</div>
            </div>
        </div>
        <div className={styles.total_price}>total：￥300,000</div>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <div className={styles.price_wrapper}>
            <div className={styles.row}>
                <div>ランディングページ デザイン制作</div>
                <div>￥200,000</div>
            </div>
            <div className={styles.row}>
                <div>ランディングページ コーディング実装</div>
                <div>￥100,000</div>
            </div>
            <div className={styles.row}>
                <div>その他オプション</div>
                <div>各種オプション料金をご確認下さい。</div>
            </div>
        </div>
        <div className={styles.total_price}>total：￥300,000～</div>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <div className={styles.price_wrapper}>
            <div className={styles.row}>
                <div>リリース作業</div>
                <div>￥30,000</div>
            </div>
            <div className={styles.row}>
                <div>各種計測タグの埋め込み</div>
                <div>￥10,000</div>
            </div>
            <div className={styles.row}>
                <div>WEBサーバー代理構築</div>
                <div>￥50,000～</div>
            </div>
            <div className={styles.row}>
                <div>Googleアナリティクスの設定代行</div>
                <div>￥30,000</div>
            </div>
            <div className={styles.row}>
                <div>広告用バナー作成</div>
                <div>￥10,000～</div>
            </div>
            <div className={styles.row}>
                <div>メールフォーム作成</div>
                <div>￥30,000～</div>
            </div>
        </div>
      </TabPanel>
    </Box>
  );
}